import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { BaseComponent } from '../../../base/base.component';
import { SelectOptionComponent } from './select-option.component';

@Component({
  selector: 'app-work-status-option',
  imports: [SelectOptionComponent],
  template: `
    <app-select-option
      label="The work status is"
      [control]="control"
      [showList]="true"
      [listControl]="listControl"
      [items]="alerts.workStatus"
      [multiple]="true"
      [filter]="false"
      [listControlRequired]="true"
    />
  `,
  styles: ``,
})
export class WorkStatusOptionComponent extends BaseComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  listControl: FormControl<any>;

  @Input()
  control: FormControl<any[]>;

  async ngOnInit() {
    if (this.listControl.value == null) {
      this.listControl.setValue(
        this.alerts.find(this.alerts.listItems, 'InList'),
      );
    }

    this.control.setValidators([Validators.required]);
    if (this.control.value == null) {
      this.control.setValue([]);
    }
  }
}
